var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg003BDomeKamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 451.6669999999999,
    height: 451.6669999999999,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -1,
    width: 272.459228,
    height: 272.459228,
    id: "canvas_background",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("ellipse", {
    ry: 213.823302,
    rx: 213.74094,
    id: "svg_5",
    cy: 225.79493,
    cx: 224.459066,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#f2f2f2",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#777f8e",
    strokeWidth: "null",
    x: 69.743184,
    y: 91.851221,
    width: 314.135826,
    height: 34.541906,
    id: "svg_14"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#777f8e",
    strokeWidth: "null",
    x: 69.743186,
    y: 91.851224,
    width: 84.725435,
    height: 88.635832,
    id: "svg_15",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#777f8e",
    strokeWidth: "null",
    x: 298.501855,
    y: 92.502958,
    width: 84.725435,
    height: 88.635832,
    id: "svg_16",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#777f8e",
    stroke: "null",
    strokeWidth: "null",
    strokeOpacity: "null",
    fillOpacity: "null",
    cx: 160.334221,
    cy: 134.213936,
    id: "svg_17",
    rx: 20.855491,
    ry: 16.945086
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#777f8e",
    strokeWidth: "null",
    strokeOpacity: "null",
    fillOpacity: "null",
    cx: 295.569054,
    cy: 132.910468,
    id: "svg_18",
    rx: 27.698701,
    ry: 18.900288,
    stroke: "null"
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "null",
    fill: "#777f8e",
    strokeWidth: "null",
    strokeOpacity: "null",
    fillOpacity: "null",
    cx: 113.395981,
    cy: 197.798137,
    id: "svg_19",
    rx: 32.877359,
    ry: 69.775352,
    transform: "rotate(-24 113.39597320556638,197.79814147949222) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#777f8e",
    strokeWidth: "null",
    strokeOpacity: "null",
    fillOpacity: "null",
    cx: 338.866694,
    cy: 197.674303,
    id: "svg_20",
    rx: 32.877359,
    ry: 68.101015,
    transform: "rotate(-160 338.86669921874994,197.67430114746097) ",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    fill: "#e3e8ee",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 149.087906,
    y: 168.911973,
    width: 151.563965,
    height: 112.946642,
    id: "svg_6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "null",
    ry: 85.479814,
    rx: 77.557288,
    id: "svg_8",
    cy: 208.07733,
    cx: 227.501389,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#ff0033",
    stroke: "null",
    strokeWidth: "null",
    strokeOpacity: "null",
    cx: 226.159363,
    cy: 198.735611,
    id: "svg_21",
    rx: 48.880056,
    ry: 48.880056
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#e3e8ee",
    stroke: "null",
    strokeWidth: "null",
    strokeOpacity: "null",
    cx: 227.462831,
    cy: 201.668413,
    id: "svg_22",
    rx: 11.079479,
    ry: 13.360549
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#193351",
    strokeWidth: "null",
    strokeOpacity: "null",
    x: 36.504746,
    y: 7.12579,
    width: 382.567913,
    height: 76.252886,
    id: "svg_7",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m257.771715,48.032019c-4.381706,0 -7.937872,3.573335 -7.937872,7.976194s3.556167,7.976194 7.937872,7.976194c4.381706,0 7.937872,-3.573335 7.937872,-7.976194s-3.556167,-7.976194 -7.937872,-7.976194z",
    id: "svg_1",
    fill: "#193351",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m421.291887,0.174856l-390.543323,0c-4.384087,0 -7.937872,3.57174 -7.937872,7.976194l0,47.857163c0,20.915973 16.109912,38.109457 36.514213,39.742183l0,40.019755c0,61.845812 33.408124,116.060001 83.340516,145.083776c0.061915,0.035893 0.124625,0.070988 0.187334,0.106881c0.002381,0.001595 0.004763,0.00319 0.007144,0.003988c25.174169,14.591649 53.924349,22.305426 83.160327,22.305426c30.256788,0 59.136356,-8.28248 83.354804,-22.416295l-0.000794,0.000798c24.881261,-14.462435 45.749134,-35.259563 60.347675,-60.143692c15.042268,-25.642666 22.993635,-55.014202 22.993635,-84.940881l0,-40.019755c20.404301,-1.631929 36.514213,-18.82621 36.514213,-39.742183l0,-47.857163c0,-4.404454 -3.553785,-7.976194 -7.937872,-7.976194l0,-0.000001zm-123.83081,269.088066c-21.84185,11.821517 -46.440523,18.054912 -71.440852,18.054912c-24.999535,0 -49.598208,-6.233395 -71.440852,-18.054912l0,-69.68322c0,-39.58266 32.048366,-71.785745 71.440852,-71.785745c39.392486,0 71.440852,32.203085 71.440852,71.785745l0,69.68322zm79.378724,-133.492771c0,49.165259 -24.020002,95.301957 -63.502979,123.560814l0,-59.751263c0,-48.378806 -39.170225,-87.738132 -87.316597,-87.738132s-87.316597,39.359326 -87.316597,87.738132l0,59.751263c-39.482977,-28.258857 -63.502979,-74.395555 -63.502979,-123.560814l0,-39.880969l301.639152,0l0,39.880969zm36.514213,-87.738132l-123.83081,0c-4.384087,0 -7.937872,3.57174 -7.937872,7.976194c0,4.404454 3.553785,7.896432 7.937872,7.896432l122.465496,0c-3.276754,9.283492 -12.100493,16.03215 -22.448303,16.03215c-29.024037,0 -286.874709,0 -327.040343,0c-13.130829,0 -23.813617,-10.734362 -23.813617,-23.928582l0,-39.880969l374.667578,0l0,31.904775l-0.000001,0z",
    id: "svg_2",
    fill: "#193351",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226.020226,143.746345c-30.6386,0 -55.565107,25.046844 -55.565107,55.833357c0,30.786513 24.926507,55.833357 55.565107,55.833357c30.6386,0 55.565107,-25.046844 55.565107,-55.833357c0,-30.786513 -24.926507,-55.833357 -55.565107,-55.833357zm0,95.714326c-21.884714,0 -39.689362,-17.890603 -39.689362,-39.880969s17.804648,-39.880969 39.689362,-39.880969s39.689362,17.890603 39.689362,39.880969s-17.804648,39.880969 -39.689362,39.880969z",
    id: "svg_3",
    fill: "#193351",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226.020226,175.651121c-13.130829,0 -23.813617,10.734362 -23.813617,23.928582s10.682789,23.928582 23.813617,23.928582s23.813617,-10.734362 23.813617,-23.928582s-10.682789,-23.928582 -23.813617,-23.928582zm0,31.904775c-4.376943,0 -7.937872,-3.578121 -7.937872,-7.976194c0,-4.398073 3.56093,-7.976194 7.937872,-7.976194c4.376943,0 7.937872,3.578121 7.937872,7.976194c0,4.398073 -3.56093,7.976194 -7.937872,7.976194z",
    id: "svg_4",
    fill: "#193351",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "null",
    strokeWidth: "null",
    strokeOpacity: "null",
    fillOpacity: "null",
    points: "147.9512735803068,275.6402314866398 147.9512735803068,275.6402314866398 147.9512735803068,275.6402314866398 ",
    id: "svg_9",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "null",
    strokeWidth: "null",
    strokeOpacity: "null",
    fillOpacity: "null",
    points: "202.69693626758067,293.23705163612067 204.00040442680142,293.23705163612067 ",
    id: "svg_10",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "null",
    strokeWidth: "null",
    strokeOpacity: "null",
    fillOpacity: "null",
    points: "312.8399957217388,271.7298270089774 312.8399957217388,271.7298270089774 312.8399957217388,271.7298270089774 ",
    id: "svg_11",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#e3e8ee",
    stroke: "null",
    strokeWidth: "null",
    strokeOpacity: "null",
    cx: 621.436082,
    cy: 207.208153,
    id: "svg_23",
    rx: 0.325867
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "svg_12",
    cy: 224.339343,
    cx: 169.95889,
    strokeOpacity: "null",
    strokeWidth: "null",
    stroke: "null",
    fill: "#e3e8ee"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg003BDomeKamera);
export default __webpack_public_path__ + "static/media/003b-Dome-Kamera.3e4a7802a6a79ca81c1f545be40c3159.svg";
export { ForwardRef as ReactComponent };